import React from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { IoIosMailUnread } from "react-icons/io";
import { AiFillInstagram } from "react-icons/ai";

const Contact = () => {
  return (
    <section
      id="contact"
      className="relative overflow-hidden bg-[#9BDAF2] lg:pt-20"
    >
      <div className="relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-x-24">
          <div className="pt-12 sm:pt-16 lg:py-36">
            <h2 className="text-h2 font-sans uppercase text-white sm:text-4xl lg:text-5xl xl:text-6xl leading-none">
              Un coaching <br />
              <span className="text-slate-950">qui te ressemble.</span>
            </h2>
            <p className="mt-4 text-p text-slate-950 sm:mt-6 sm:text-xl">
              N'hésite pas à me contacter pour plus d'informations concernant
              mes prestations.
            </p>
            <div className="w-fit text-start lg:flex lg:flex-col lg:justify-center mt-5">
              <ul className="my-5 space-y-2">
                <li className="flex items-center text-p  text-slate-950">
                  <span className="mr-3 text-lg">
                    {" "}
                    <FaPhoneAlt />
                  </span>
                  07 89 29 18 53
                </li>

                <li className="flex items-center text-p  text-slate-950">
                  <span className="mr-3 text-lg">
                    {" "}
                    <IoIosMailUnread />
                  </span>
                  baptisteboule@sfr.fr
                </li>

                <li className="flex items-center text-p  text-slate-950">
                  <span className="mr-3 text-lg">
                    {" "}
                    <AiFillInstagram />
                  </span>
                  @bapt.tips
                </li>
              </ul>
            </div>
          </div>

          <div className="self-end mt-12 lg:mt-0">
            <img
              className="w-full max-w-sm mx-auto transform xl:translate-y-16 lg:max-w-none"
              src="/img/Mockup_hand.webp"
              alt="Compte instagram de Baptiste"
              loading="lazy"
              width="560"
              height="792.16"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
